import { Link } from "react-router";
import { all_routes } from "../../../../router/all_routes";

interface Props {
    activeTab:  'chatSettings' | 'chatTokenTopup' | 'chatTokenUsage' | 'chatTopupHistory';
}

const ChatSettingsMenu = ({activeTab}:Props) => {
    const routes = all_routes;


    return (
        <>
            <Link
                to={routes.chatSettings}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'chatSettings' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Token Settings
            </Link>
            <Link
                to={routes.chatTokenUsage}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'chatTokenUsage' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Token Usage
            </Link>
            <Link
                to={routes.chatTopupSettings}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'chatTokenTopup' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Token Topup
            </Link>
            <Link
                to={routes.chatTopupHistory}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'chatTopupHistory' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Token Topup History
            </Link>
        </>
    )
}

export default ChatSettingsMenu;